<template>
    <div>
        <div v-if="!errorMessage">
            <p class="text-left w-fonts-text-medium">
                <b>Complete your information</b>
            </p>
            <p>Please review and provide any missing information to finish signup.</p>
            <div class="row">
                <div class="col-sm-12 pb-0">


                    <CodeVerification v-if="verificateEmail" :email="email" @registry="verifyEmailNewUser"></CodeVerification>

                    <v-form v-else
                            ref="form"
                            name="frm"
                            lazy-validation
                            @submit.prevent="submitRegistry"
                            method="post"
                        >
                            <v-text-field
                                v-model="email"
                                outlined
                                :rules="[rules.required, rules.email]"
                                :disabled="disableEmail"
                                name="email"
                                placeholder="Email address"
                                append-icon="fal fa-envelope"
                            ></v-text-field>

                            <div class="row">
                                <div class="col-md-6 pt-0 pb-0">
                                    <v-text-field
                                        v-model="firstName"
                                        outlined
                                        :rules="[rules.required]"
                                        name="first_name"
                                        placeholder="First name"
                                        append-icon="fal fa-user-alt"
                                    ></v-text-field>
                                </div>
                                <div class="col-md-6 pt-0 pb-0">
                                    <v-text-field
                                        v-model="lastName"
                                        outlined
                                        :rules="[rules.required]"
                                        name="last_name"
                                        placeholder="Last name"
                                        append-icon="fal fa-user-alt"
                                    ></v-text-field>
                                </div>
                            </div>


                            <hr class="mt-0 mb-3">
                            <p class="text-center w-fonts-text-medium mb-3">I want to:</p>
                            <user-role-selector v-model="role" :errors="userRoleSelectorErrors"></user-role-selector>

                            <v-btn block name="Signup" type="submit" :loading="loading" large class="text-white mt-3" color="#ff5a5f">
                                Finish signing up
                            </v-btn>
                    </v-form>


                </div>
            </div>
        </div>
        <div v-else>
            <p class="text-left w-fonts-text-medium">
                <b>{{errorMessage}}</b>
            </p>
        </div>
    </div>
</template>

<script>
    import UserRoleSelector from "@/components/auth/UserRoleSelector.vue";
    import Toolbox from "@/shared/toolbox";

    import {sendAuth} from './auth';

    export default {
        props: {
            profile: Object,
            url: String,
        },
        mixins: [sendAuth],
        name: "CompleteInformation",
        data: () => ({
            email: null,
            role: null,
            firstName: null,
            lastName: null,
            accessToken: null,
            errorMessage: null,
            rules: {
                required: value => {
                    if (value) {
                        if (value.trim()) {
                            return true;
                        } else {
                            return 'Required.';
                        }
                    } else {
                        return 'Required.';
                    }
                },
                email: (v) => /^[a-zA-Z0-9.!#$%&’*+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v) || 'E-mail must be valid'
            },
            token: null,
            credential: null,
            uid: null,
            loading: false,
            disableEmail: false,
            verificateEmail: false,
            userRoleSelectorErrors: [],
        }),
        components: {
            UserRoleSelector,
            CodeVerification: () => import('./CodeVerification.vue')
        },
        created() {
            this.email = this.profile.email;

            if (this.profile.email) {
                this.disableEmail = true;
            }

            this.firstName = this.profile.first_name;
            this.lastName = this.profile.last_name;
            this.accessToken = this.profile.access_token;
            this.token = this.profile.token;
            this.credential = this.profile.credential;
            this.uid = this.profile.uid;

            console.debug('Current role: ', this.role);
        },
        computed: {
            comProfile() {
                return {
                    email: this.email,
                    first_name: this.firstName,
                    last_name: this.lastName,
                    access_token: this.accessToken,
                    role: this.role,
                    finish_registration: true,
                    token: this.token,
                    credential: this.credential,
                    userID: this.uid
                }
            }
        },
        methods: {
            verifyEmailNewUser(e) {
                this.sendLoginSocial(this.comProfile, this.url, ($data) => {
                    if ($data.id) {
                        e(true);

                        this.$emit('loggedIn');
                    } else if ($data.error) {
                        this.errorMessage = $data.error;
                    }
                });
            },
            submitRegistry() {
                if (this.$refs.form.validate()) {
                    if (!this.role) {
                        this.userRoleSelectorErrors = ["Please select a user role"];
                        return false;
                    }

                    this.loading = true;
                    this.sendLoginSocial(this.comProfile, this.url, ($data) => {
                        console.debug($data);

                        if ($data?.error) {
                            Toolbox.error($data.error);
                        }

                        if ($data?.verify) {
                            this.verificateEmail = true;
                        } else if ($data?.id) {
                            this.$emit('loggedIn');
                        }

                        this.loading = false;
                    });
                }
            }
        },
        emits: ['loggedIn'],
    }
</script>
